'use client';

import { motion } from 'framer-motion';
import { MapPin, Users, Bed, Bath, ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Image from 'next/image';
import SearchFilter from './SearchFilter';
// import SearchFilter from './SearchFilter';

export default function Hero() {
  return (
    <section id="home" className="relative md:h-[65vh] flex items-center justify-center">
      <div className="absolute inset-0">
        <Image
          src="https://images.pexels.com/photos/3320508/pexels-photo-3320508.jpeg"
          alt="Luxury Villa"
          fill
          className="object-cover"
          priority
        />
        <div className="absolute inset-0 bg-black/30" />
      </div>
      
      <div className="relative text-center text-white max-w-5xl w-full mx-auto px-4">
        {/* <motion.h1 
          className="text-5xl md:text-7xl font-bold mb-6"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          18Bricks
        </motion.h1>
        
        <motion.p 
          className="text-xl md:text-2xl mb-8 text-gray-100"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Experience Luxury Living in Paradise
        </motion.p> */}

        {/* <motion.div
          className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <div className="flex items-center gap-2 text-lg">
            <MapPin className="text-[#FFC400]" size={20} />
            <span>Bali, Indonesia</span>
          </div>
          <div className="flex items-center gap-4 text-lg">
            <div className="flex items-center gap-1">
              <Users size={20} />
              <span>8 Guests</span>
            </div>
            <div className="flex items-center gap-1">
              <Bed size={20} />
              <span>4 Bedrooms</span>
            </div>
            <div className="flex items-center gap-1">
              <Bath size={20} />
              <span>3 Bathrooms</span>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="mb-8"
        >
          <Button 
            size="lg" 
            className="bg-[#FFC400] hover:bg-[#FEAE20] text-white px-8 py-3 text-lg font-semibold"
          >
            Book Your Stay
          </Button>
        </motion.div> */}

        {/* Search Filter */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.0 }}
        >
          <SearchFilter />
        </motion.div>
      </div>

      <motion.div 
        className="absolute bottom-10 left-1/2 transform -translate-x-1/2"
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 2 }}
      >
        <ChevronDown className="text-white" size={30} />
      </motion.div>
    </section>
  );
}
